import { render, staticRenderFns } from "./VehicleAssignmentFailedRenderer.vue?vue&type=template&id=270cc148"
import script from "./VehicleAssignmentFailedRenderer.vue?vue&type=script&lang=js"
export * from "./VehicleAssignmentFailedRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports